import { SubscriptionFrequency } from "../SubscriptionFrequency.js";
import { SubscriptionKind } from "../SubscriptionKind.js";
import { SubscriptionSize } from "../SubscriptionSize.js";
import { SubscriptionVariant } from "../SubscriptionVariant.js";
import {
	type RecurringSubscriptionPricingInput,
	calculatePriceOfRecurringSubscription,
} from "./calculatePriceOfRecurringSubscription.js";
import { getSubscriptionSelectionsForVariant } from "./getSubscriptionSelectionsForVariant.js";

export function calculatePriceRangeOfRecurringSubscription(
	input: Omit<RecurringSubscriptionPricingInput, "subscription">,
): { min: number; max: number } {
	let min = Infinity;
	let max = -Infinity;
	for (const variant of Object.values(SubscriptionVariant)) {
		for (const selection of getSubscriptionSelectionsForVariant(variant)) {
			for (const size of Object.values(SubscriptionSize)) {
				for (const frequency of Object.values(SubscriptionFrequency)) {
					const { withTax } = calculatePriceOfRecurringSubscription({
						...input,
						subscription: { kind: SubscriptionKind.Recurring, variant, selection, size, frequency },
					});
					min = Math.min(min, withTax);
					max = Math.max(max, withTax);
				}
			}
		}
	}
	return { min, max };
}
